import { useParams } from 'react-router-dom';
import { Divider, Popover, Stack, Badge, Typography } from '@mui/material';
import { useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import BellIcon from '@/assets/icons/BellIcon';
import { ToolbarIconButton } from '@/components/Toolbar/ToolbarButton';
import { NotificationServiceFactory } from '@/modules/Notifications/service/NotificationServiceFactory';

import { useNotificationStore } from '../store/useNotificationStore';
import Notification from './Notification';
import NotificationsHeader from './NotificationsHeader';

export default function NotificationPopup() {
  const {
    notifications,
    markMessagesAsRead,
    hasUnreadNotifications,
    panelOpen: open,
  } = useNotificationStore();
  const notificationSvc = NotificationServiceFactory.getInstance().createNotificationService();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { alternativeId } = useParams();
  
  // rename store to match floorplan id
  useEffect(() => {
    useNotificationStore?.persist.setOptions({
      name: `notifications-${alternativeId}`,
    });
    useNotificationStore?.persist.rehydrate();
    // remove the default index
    localStorage.removeItem('notifications-store');
  }, [alternativeId]);

  const openNotificationPopup = () => {
    notificationSvc.setPanelState(true);
  };

  const handleClose = () => {
    notificationSvc.setPanelState(false);
    markMessagesAsRead();
  };

  const popup = open ? 'popup' : undefined;
  const notificationList = useMemo(() => [...notifications.values()], [notifications]);
  const { t } = useTranslation();

  return (
    <>
      <ToolbarIconButton
        // pls fix me
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        type={(open ? 'Selected' : 'Deselected') as any}
        ref={buttonRef}
        onClick={openNotificationPopup}
      >
        <Badge color='primary' variant='dot' invisible={!hasUnreadNotifications}>
          <BellIcon size={24} aria-describedby={popup} />
        </Badge>
      </ToolbarIconButton>
      <Popover
        id={popup}
        open={open}
        // plz fix me
        // eslint-disable-next-line react-hooks/refs
        anchorEl={buttonRef.current}
        onClose={handleClose}
        sx={{ ml: 3, mt: 1 }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <NotificationsHeader />
        <Divider />
        <Stack width='400px' divider={<Divider />}>
          {notificationList.length > 0 ? (
            notificationList.map((notification) => (
              <Notification key={notification.id} notification={notification} />
            ))
          ) : (
            <Stack p={2} justifyContent='center' minHeight={100}>
              <Typography textAlign='center'>
                {t('interface:notifications.no_notifications')}
              </Typography>
            </Stack>
          )}
        </Stack>
      </Popover>
    </>
  );
}
